module.exports = __webpack_public_path__ + "assets/img/lx_w_d_i_12.ca1f2135.jpg";